var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    stroke: "#808080",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.654 17.2785C5.88088 16.5234 6.34514 15.8615 6.97789 15.3911C7.61065 14.9206 8.37819 14.6667 9.16667 14.6669H12.8333C13.6228 14.6666 14.3913 14.9212 15.0245 15.3927C15.6577 15.8642 16.1218 16.5275 16.3478 17.284M2.75 11.0002C2.75 12.0836 2.96339 13.1564 3.37799 14.1574C3.7926 15.1583 4.40029 16.0678 5.16637 16.8339C5.93245 17.6 6.84193 18.2077 7.84286 18.6223C8.8438 19.0369 9.91659 19.2502 11 19.2502C12.0834 19.2502 13.1562 19.0369 14.1571 18.6223C15.1581 18.2077 16.0675 17.6 16.8336 16.8339C17.5997 16.0678 18.2074 15.1583 18.622 14.1574C19.0366 13.1564 19.25 12.0836 19.25 11.0002C19.25 9.91684 19.0366 8.84404 18.622 7.84311C18.2074 6.84217 17.5997 5.9327 16.8336 5.16661C16.0675 4.40053 15.1581 3.79284 14.1571 3.37824C13.1562 2.96364 12.0834 2.75024 11 2.75024C9.91659 2.75024 8.8438 2.96364 7.84286 3.37824C6.84193 3.79284 5.93245 4.40053 5.16637 5.16661C4.40029 5.9327 3.7926 6.84217 3.37799 7.84311C2.96339 8.84404 2.75 9.91684 2.75 11.0002ZM8.25 9.16691C8.25 9.89626 8.53973 10.5957 9.05546 11.1115C9.57118 11.6272 10.2707 11.9169 11 11.9169C11.7293 11.9169 12.4288 11.6272 12.9445 11.1115C13.4603 10.5957 13.75 9.89626 13.75 9.16691C13.75 8.43757 13.4603 7.73809 12.9445 7.22237C12.4288 6.70664 11.7293 6.41691 11 6.41691C10.2707 6.41691 9.57118 6.70664 9.05546 7.22237C8.53973 7.73809 8.25 8.43757 8.25 9.16691Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCircle);
export default __webpack_public_path__ + "static/media/user-circle.a1d08e257368836634b831799613c6f5.svg";
export { ForwardRef as ReactComponent };